import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};

function ItemsDrawings(props: Props) {
  const Navigate = useNavigate();

  return (
    <>
      <div className="min-h-full flex items-center justify-center sm:px-6 lg:px-8">
        <div className="w-full space-y-7">
          <div className="flex w-full">
            <label
              className="flex space-x-2 w-full h-80 bg-blue-50 border-2 border-blue-200 rounded-md items-center justify-center cursor-pointer hover:border-blue-100"
              htmlFor="company_icon"
            >
              <div className="flex flex-col">
                <h4 className="text-blue-200">Drag and drop files to upload</h4>
                <h4 className="text-blue-200 ml-10">JPEG/PNG/SVG</h4>
              </div>
            </label>
          </div>
          <div className="flex w-full">
            <label
              className="flex space-x-2 w-full h-12 bg-blue-50 border-2 border-blue-200 rounded-md items-center justify-center cursor-pointer hover:border-blue-100"
              htmlFor="company_icon"
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12.5" cy="12.5" r="12.5" fill="#1F78B4" />
                <path
                  d="M17.016 13.366H13.38V17.092H11.472V13.366H7.836V11.638H11.472V7.912H13.38V11.638H17.016V13.366Z"
                  fill="white"
                />
              </svg>
              <h4 className="text-blue-200">Upload Product Picture</h4>
            </label>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center pt-8 sm:px-6 lg:px-8">
        <div className="w-full space-y-8">
          <div className="flex flex-row space-x-3 justify-center">
            <div className="flex flex-col w-3/5">
              <button
                onClick={() => Navigate("/dashboard/management/items")}
                type="button"
                className="border-2 border-red-700 hover:text-white text-base font-Montserrat font-bold text-red-700 flex-shrink hover:border-red-700 hover:bg-red-700 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
              >
                Cancel
              </button>
            </div>
            <div className="flex flex-col w-1/5">
              {props.ActiveStep > 0 ? (
                <button
                  onClick={props.HandleBack}
                  type="button"
                  className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
                >
                  Previous Step
                </button>
              ) : null}
            </div>
            <div className="flex flex-col w-1/5">
              <button
                onClick={props.HandleNext}
                type="button"
                className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ItemsDrawings;
